import React from 'react';
import SSHAccess from '../components/challenges/challengeDetailSections/challengeCFNTemplate/SSHAccess';

export const ChallengesSshAccessPage: React.FC = () => {
  return <SSHAccess />;
};
